<template>
<v-card
  class="pa-4 rounded-lg fill-height"
  elevation="0"
  style="border: 1px solid #e0e0e0; transition: all 0.2s;"
  hover
>
  <div class="d-flex justify-space-between align-center flex-nowrap">
    <div style="width: 100%;">
      <div class="mb-2">
        <v-skeleton-loader
          type="heading"
          class="mb-2"
          style="max-width: 60%;"
        ></v-skeleton-loader>
      </div>
      <v-skeleton-loader
        type="sentences"
        class="mb-4"
        style="max-width: 90%;"
      ></v-skeleton-loader>
    </div>

    <div
      v-if="action"
      class="d-flex gap-2 ml-2"
      style="min-width: 70px; justify-content: flex-end;"
    >
      <v-skeleton-loader
        type="circle"
        width="32"
        height="32"
        class="mr-1"
      ></v-skeleton-loader>
      <v-skeleton-loader
        type="circle"
        width="32"
        height="32"
      ></v-skeleton-loader>
    </div>
  </div>

  <div class="mt-2">
    <v-skeleton-loader
      type="chip"
      width="80"
      height="24"
    ></v-skeleton-loader>
  </div>
</v-card>
</template>

<script>
export default {
  name: 'CardItemSkeleton',
  props: {
    action: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped lang="scss">
.v-skeleton-loader {
  margin: 0;

  ::v-deep .v-skeleton-loader__bone {
    border-radius: 4px;
  }

  ::v-deep .v-skeleton-loader__sentences .v-skeleton-loader__text {
    height: 12px;
    margin-bottom: 6px;
  }
}
</style>
